import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {TagModel} from "../../../api/model/tag.model";
import {TagConverter} from "../../../api/model/tag.converter";


@Injectable({providedIn: 'root'})
export class TagDataService extends AbstractDataServiceV2<TagModel, TagConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: TagConverter) {
        super('Tag', http, httpUrlGenerator, logger, config, converter);
    }
}
